import { Entity, Field } from 'typegraph';

@Entity({ create: "purchase" })
export class Payment {

    @Field()
    entityId: number;

}


// WEBPACK FOOTER //
// ./src/panels/checkout/entities/Payment.ts